// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This is CSS that is applied to the home page */

/* ALL COMMON content between hero and footer */
/* SECTION CONTAINERS */
.section-ct {
  padding: 20px 5px;
}

.section-ct .section-heading-ct {
  display: flex;
  justify-content: center;
}

.section-ct .section-heading-ct h2 {
  border-radius: 30px;
  text-align: center;
  font-size: 300%;
  margin: 0 0 5px 0;
  font-family: var(--font-family1);
  padding: 10px;
}

.section-ct h3 {
  font-size: 150%;
  font-family: var(--font-family1);
}

.section-ct p, .section-ct li {
  font-size: 20px;
  line-height: 1.8rem;
  font-weight: 540;
  font-family: var(--font-family1);
}

.section-ct a {
  color: var(--brand-blue1);
}


/* ALL CARD GROUPS */
.card-gp {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 20px 5px;
}




/* ABOUT SECTION */
.about-section-ct {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px 10px;
}

.about-section-ct .about-chase-bio {
  max-width: 500px;
  padding: 0 5px;
}

/* first p of bio */
.about-chase-bio :nth-child(1) {
  margin-top: 0;
}
.about-chase-bio :last-child {
  margin-bottom: 10px;
}
.about-chase-bio p {
  text-indent: 2rem;
}

#about blockquote {
  font-weight: bold;
  font-size: 1.1rem;
  font-family: var(--font-family1);
  text-align: center;
}

.about-section-ct .about-img-ct {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.about-section-ct img {
  width: 100%;
  max-width: 360px;
  /* max-height: ; */
  border: 1px solid black;
  border-radius: 10px;
  border-top: 1px solid var(--brand-white3);
  border-left: 1px solid var(--brand-white3);
  box-shadow: 3px 3px 3px var(--brand-white3);
}



/* THINGS TO THINK ABOUT SECTION */
.things-to-think-about-list-ct {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.things-to-think-about-list-ct li::marker {
  font-size: 1.5rem;
  color: var(--brand-red1);
  content: "? ";
  font-family: monospace;
}
.things-to-think-about-list-ct li {
  margin-bottom: 8px;
}
.things-to-think-about-list-ct li p {
  display: inline;
}



/* WHY CHOOSE CONTEXT CODING SECTION */
#why-choose-context {
  background-image: url("https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/gear_head.webp");
  background-size: cover;
  background-position: center;
}




/* COMES WITH SECTION */
.comes-with-list-ct {
  display: flex;
  justify-content: center;
}

.comes-with-list-ct a {
  color: var(--brand-blue1);
}
.comes-with-list-ct a:hover {
  color: blue;
}

.comes-with-list-ct li p {
  margin: 8px 0;
}

.comes-with-list-ct li::marker {
  color: var(--brand-red1);
  font-size: 1.8rem;
}

/* TESTING */








@media (max-width: 4075px) {
  .section-ct h2 {
    font-size: 210%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,+CAA+C;AAC/C,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf;;;;;AAKA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;AAC7C;;;;AAIA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;;;AAIA,sCAAsC;AACtC;EACE,+HAA+H;EAC/H,sBAAsB;EACtB,2BAA2B;AAC7B;;;;;AAKA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,YAAY;;;;;;;;;AASZ;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* This is CSS that is applied to the home page */\n\n/* ALL COMMON content between hero and footer */\n/* SECTION CONTAINERS */\n.section-ct {\n  padding: 20px 5px;\n}\n\n.section-ct .section-heading-ct {\n  display: flex;\n  justify-content: center;\n}\n\n.section-ct .section-heading-ct h2 {\n  border-radius: 30px;\n  text-align: center;\n  font-size: 300%;\n  margin: 0 0 5px 0;\n  font-family: var(--font-family1);\n  padding: 10px;\n}\n\n.section-ct h3 {\n  font-size: 150%;\n  font-family: var(--font-family1);\n}\n\n.section-ct p, .section-ct li {\n  font-size: 20px;\n  line-height: 1.8rem;\n  font-weight: 540;\n  font-family: var(--font-family1);\n}\n\n.section-ct a {\n  color: var(--brand-blue1);\n}\n\n\n/* ALL CARD GROUPS */\n.card-gp {\n  display: flex;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n  gap: 20px 5px;\n}\n\n\n\n\n/* ABOUT SECTION */\n.about-section-ct {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 15px 10px;\n}\n\n.about-section-ct .about-chase-bio {\n  max-width: 500px;\n  padding: 0 5px;\n}\n\n/* first p of bio */\n.about-chase-bio :nth-child(1) {\n  margin-top: 0;\n}\n.about-chase-bio :last-child {\n  margin-bottom: 10px;\n}\n.about-chase-bio p {\n  text-indent: 2rem;\n}\n\n#about blockquote {\n  font-weight: bold;\n  font-size: 1.1rem;\n  font-family: var(--font-family1);\n  text-align: center;\n}\n\n.about-section-ct .about-img-ct {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.about-section-ct img {\n  width: 100%;\n  max-width: 360px;\n  /* max-height: ; */\n  border: 1px solid black;\n  border-radius: 10px;\n  border-top: 1px solid var(--brand-white3);\n  border-left: 1px solid var(--brand-white3);\n  box-shadow: 3px 3px 3px var(--brand-white3);\n}\n\n\n\n/* THINGS TO THINK ABOUT SECTION */\n.things-to-think-about-list-ct {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.things-to-think-about-list-ct li::marker {\n  font-size: 1.5rem;\n  color: var(--brand-red1);\n  content: \"? \";\n  font-family: monospace;\n}\n.things-to-think-about-list-ct li {\n  margin-bottom: 8px;\n}\n.things-to-think-about-list-ct li p {\n  display: inline;\n}\n\n\n\n/* WHY CHOOSE CONTEXT CODING SECTION */\n#why-choose-context {\n  background-image: url(\"https://s3.g.s4.mega.io/2ijnsv4opkr3vvr6zwjtrqfdrjtysegsktpws/context-coding/public/img/gear_head.webp\");\n  background-size: cover;\n  background-position: center;\n}\n\n\n\n\n/* COMES WITH SECTION */\n.comes-with-list-ct {\n  display: flex;\n  justify-content: center;\n}\n\n.comes-with-list-ct a {\n  color: var(--brand-blue1);\n}\n.comes-with-list-ct a:hover {\n  color: blue;\n}\n\n.comes-with-list-ct li p {\n  margin: 8px 0;\n}\n\n.comes-with-list-ct li::marker {\n  color: var(--brand-red1);\n  font-size: 1.8rem;\n}\n\n/* TESTING */\n\n\n\n\n\n\n\n\n@media (max-width: 4075px) {\n  .section-ct h2 {\n    font-size: 210%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
